import { usePageRequest } from './usePageRequest'
import api from './api'
import { LinkProfile } from '../models'

export const useLinkProfile = () => {
    const { data: linkProfiles, loading, refreshAsync: getLinkProfiles } = usePageRequest(
        () => api.get<LinkProfile[]>('v1/link_profile/').then((response) => {
           return response.data
        }),
        {},
        { globalLoading: false }
    )

    return {
        loading,
        linkProfiles,
        getLinkProfiles
    }
}